// ─────────────────────────────────────────────────────────────────────────
//  INFORMATIONS LÉGALES DE L'ÉDITEUR — À COMPLÉTER PAR L'UTILISATEUR
//  Remplacez chaque valeur "[À COMPLÉTER …]" par vos informations réelles.
//  Ces données alimentent automatiquement les Mentions légales, les CGU/CGV
//  et la Politique de confidentialité. Un seul endroit à mettre à jour.
// ─────────────────────────────────────────────────────────────────────────
export const COMPANY = {
  appName: "BIZARRE AI",
  raisonSociale: "[À COMPLÉTER — Raison sociale / Nom de l'entreprise]",
  formeJuridique: "[À COMPLÉTER — ex : SAS, SARL, auto-entrepreneur]",
  capital: "[À COMPLÉTER — Capital social, si société]",
  siret: "[À COMPLÉTER — Numéro SIRET / SIREN]",
  rcs: "[À COMPLÉTER — Ville d'immatriculation RCS]",
  tva: "[À COMPLÉTER — N° TVA intracommunautaire, si applicable]",
  adresse: "[À COMPLÉTER — Adresse postale complète]",
  email: "[À COMPLÉTER — E-mail de contact]",
  telephone: "[À COMPLÉTER — Téléphone (optionnel)]",
  directeurPublication: "[À COMPLÉTER — Nom du directeur / de la directrice de la publication]",
  // Hébergeur (Emergent par défaut — adaptez si vous déployez ailleurs)
  hebergeur: "[À COMPLÉTER — Nom de l'hébergeur]",
  hebergeurAdresse: "[À COMPLÉTER — Adresse de l'hébergeur]",
  // Délégué à la protection des données (facultatif)
  dpoEmail: "[À COMPLÉTER — E-mail DPO / contact RGPD]",
  updated: "Juin 2026",
};
